import { render } from "./InventoryPage.vue?vue&type=template&id=0300e06b&ts=true"
import script from "./InventoryPage.vue?vue&type=script&lang=ts"
export * from "./InventoryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__